export default __webpack_public_path__ + "static/media/noodles.60ac4bec.png";